// API utility functions
export const getApiBaseUrl = () => {
  // In development, use the current hostname with port 5000
  // This allows access from other devices on the network
  if (process.env.NODE_ENV === 'development') {
    return `http://${window.location.hostname}:5000`;
  }
  // In production, use relative URLs
  return '';
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // Otherwise, prepend the API base URL
  return `${getApiBaseUrl()}${imagePath}`;
};

/**
 * Get thumbnail URL for an image path
 * @param {string} imagePath - Original image path
 * @returns {string} - Thumbnail URL
 */
export const getThumbnailUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If it's already a full URL, convert to thumbnail
  if (imagePath.startsWith('http')) {
    return imagePath.replace(/(\.[^.]+)$/, '_thumb$1');
  }
  
  // Convert relative path to thumbnail path
  const thumbnailPath = imagePath.replace(/(\.[^.]+)$/, '_thumb$1');
  return `${getApiBaseUrl()}${thumbnailPath}`;
};

/**
 * Get the best image URL based on context
 * @param {string} imagePath - Original image path
 * @param {boolean} useThumbnail - Whether to use thumbnail (true for small displays)
 * @returns {string} - Appropriate image URL
 */
export const getBestImageUrl = (imagePath, useThumbnail = false) => {
  return useThumbnail ? getThumbnailUrl(imagePath) : getImageUrl(imagePath);
};

export const sanitizeDownloadFilename = (name, ext = 'pdf') => {
  const base = (name || 'file')
    .replace(/[^\w\s.-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
  return base.toLowerCase().endsWith(`.${ext}`) ? base : `${base || 'file'}.${ext}`;
};

export const downloadFileFromUrl = async (url, filename = 'download.pdf') => {
  if (!url) return;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
